
import { useEffect } from 'react';
import performanceOptimizations from '../utils/performanceOptimizations';

/**
 * Component that applies performance optimizations when mounted
 * This component doesn't render anything visible
 */
const PerformanceOptimizations = () => {
  useEffect(() => {
    // Add resource hints (preconnect, preload)
    performanceOptimizations.addResourceHints();
    
    // Optimize images
    performanceOptimizations.optimizeImages();
    
    // Log that the performance optimizations have been applied
    console.log('Performance optimizations applied, including hero image preload');
    
    // Log the hero image URL to verify it's correct
    console.log('Hero image URL:', '/lovable-uploads/ac7da958-8971-47d6-8588-0611fa790b37.png');
    
    // Remove unused styles (in production)
    if (process.env.NODE_ENV === 'production') {
      // Wait for the page to fully load before removing unused styles
      window.addEventListener('load', () => {
        setTimeout(() => {
          const unusedStyles = document.querySelectorAll(
            'style:not([data-used]), link[rel="stylesheet"]:not([data-used])'
          );
          unusedStyles.forEach(style => {
            if (!style.hasAttribute('data-critical')) {
              style.setAttribute('media', 'print');
              style.setAttribute('data-unused', 'true');
            }
          });
        }, 2000);
      });
    }
  }, []);

  return null;
};

export default PerformanceOptimizations;
